import SplitEstate from "../../Components/SplitEstate";
const SplitEstatePage = () => {
  return (
      <>
        <SplitEstate />
      </>
  );
};

export default SplitEstatePage;
